module.exports = __webpack_public_path__ + "img/euromat-logo.a604273d.svg";